import InvestorType from './InvestorType'

const investorReducer = (state, action) => {
  switch (action.type) {
    case InvestorType.GET_INVESTORS:
      return {
        ...state,
        investors: action.payload,
        loading: false,
      }
    case InvestorType.GET_INVESTOR:
      return {
        ...state,
        investor: action.payload,
        loading: false,
      }
    case InvestorType.UPDATE_INVESTOR:
      return {
        ...state,
        investor: action.payload,
        loading: false,
      }
    case InvestorType.GET_REQUEST_INVEST:
      return {
        ...state,
        requests: action.payload,
        loading: false,
      }
    case InvestorType.GET_REQUEST_INVEST_BY_STARTUP_ID:
      return {
        ...state,
        requests: action.payload,
        loading: false,
      }
    case InvestorType.GET_REQUEST_INVEST_BY_INVESTOR_ID:
      return {
        ...state,
        requests: action.payload,
        loading: false,
      }
    case InvestorType.CHANGE_REQUEST_INVEST:
      return {
        ...state,
        request: action.payload,
        loading: false,
      }
    case InvestorType.GET_INVOICES_BY_ADMIN:
      return {
        ...state,
        invoices: action.payload,
        loading: false,
      }
    case InvestorType.CREATE_TICKET:
      return {
        ...state,
        ticket: action.payload,
        loading: false,
      }
    case InvestorType.CREDIT_CHARGE_MANUAL:
      return {
        ...state,
        loading: false,
      }
    case InvestorType.GET_RECEIPT_INVOICES:
      return {
        ...state,
        invoices: action.payload,
        loading: false,
      }
    case InvestorType.GET_INVESTOR_MANAGERS:
      return {
        ...state,
        admins: action.payload,
        loading: false,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}

export default investorReducer
